import type { Prisma } from '@prisma/client'
import { Check, ChevronsUpDown } from 'lucide-react'
import { useState } from 'react'
import { cn } from '#app/utils/misc'
import { Button } from './ui/button'
import {
	Command,
	CommandEmpty,
	CommandGroup,
	CommandInput,
	CommandItem,
	CommandList,
} from './ui/command'
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover'
import { useImmunologicalBackgroundParams } from './use-immunological-background-params'

export function ImmunologicalBackgroundFilter({
	options,
}: {
	options: Prisma.ImmunologicalBackgroundGetPayload<{
		include: {
			_count: {
				select: { pmhcs: true }
			}
		}
	}>[]
}) {
	const [open, setOpen] = useState(false)
	const {
		toggleImmunologicalBackgroundParam,
		selectedImmunologicalBackground,
	} = useImmunologicalBackgroundParams()

	return (
		<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger asChild>
				<Button
					variant="outline"
					role="combobox"
					aria-expanded={open}
					className="w-full justify-between"
				>
					{selectedImmunologicalBackground.length > 0
						? selectedImmunologicalBackground.join(', ')
						: 'Select immunological background...'}
					<ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
				</Button>
			</PopoverTrigger>
			<PopoverContent className="w-full bg-white p-0">
				<Command>
					<CommandInput placeholder="Search immunological background..." />
					<CommandList>
						<CommandEmpty>No immunological background found.</CommandEmpty>
						<CommandGroup>
							{options.map(option => (
								<CommandItem
									key={option.id}
									value={option.id}
									onSelect={(currentValue: string) => {
										toggleImmunologicalBackgroundParam(currentValue)
									}}
								>
									<Check
										className={cn(
											'mr-2 h-4 w-4',
											selectedImmunologicalBackground.includes(option.id)
												? 'opacity-100'
												: 'opacity-0',
										)}
									/>
									{`${option.id} (${option._count.pmhcs})`}
								</CommandItem>
							))}
						</CommandGroup>
					</CommandList>
				</Command>
			</PopoverContent>
		</Popover>
	)
}
